module.exports = __webpack_public_path__ + "static/media/practitioner-07.5c1a5571.jpg";